// TanStack Router instance.
//
// The route tree is auto-generated by @tanstack/router-vite-plugin from
// src/routes/. The plugin writes src/routeTree.gen.ts on dev startup and
// before each build; if you delete it locally, restart `npm run dev` or
// run `npm run build` once.

import { createRouter } from '@tanstack/react-router';
import type { QueryClient } from '@tanstack/react-query';
import { routeTree } from './routeTree.gen';

export function makeRouter(queryClient: QueryClient): ReturnType<
  typeof createRouter
> {
  return createRouter({
    routeTree,
    context: { queryClient },
    defaultPreload: 'intent',
    defaultPreloadStaleTime: 0,
  });
}

declare module '@tanstack/react-router' {
  interface Register {
    router: ReturnType<typeof makeRouter>;
  }
}
